export enum JobOfferSort {
  relevance = 'relevance',
  publication = 'publication',
}
